import { Alert, AlertIcon, Box } from '@chakra-ui/react';
import Field from 'components/general/Field';
import { DocumentTemplatesQuery } from 'generated/graphql';
import { useFormContext, useWatch } from 'react-hook-form';

interface Props {
  templates: NonNullable<DocumentTemplatesQuery['documentTemplates']['edges'][number]['node']>[];
}

function DocumentRenewalForm({ templates }: Props) {
  const { getValues } = useFormContext();
  const [nonExpiring, eSign] = useWatch({ name: ['nonExpiring', 'eSign'] });

  return (
    <Box>
      <Field name="eSign" label="Send document for eSignature" type="checkbox" mt={4} mb={10} />
      {eSign && (
        <>
          <Field
            name="templateId"
            label="Template"
            type="select"
            placeholder="Select a template"
            register={{ required: 'Template is required' }}
          >
            {templates.map(template => (
              <option key={template.id} value={template.esignTemplateId}>
                {template.name}
              </option>
            ))}
          </Field>
          <Alert status="warning" mt={4} mb={4}>
            <AlertIcon />
            By clicking &quot;Save&quot; below, an email will be sent to the client with a link to
            eSign this document.
          </Alert>
        </>
      )}
      {!eSign && (
        <>
          <Field
            name="expiresOn"
            label="Suggested Expiration Date"
            type="date"
            isDisabled={nonExpiring}
            mt={4}
          />
          <Field
            name="nonExpiring"
            label="Non-Expiring"
            type="checkbox"
            mt={4}
            register={{
              validate: value => !!getValues('expiresOn') || value,
            }}
          />
          <Field
            name="file"
            label="New File"
            type="file"
            register={{ required: 'File is required' }}
            mt={4}
          />
        </>
      )}
    </Box>
  );
}

export default DocumentRenewalForm;
